var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("filters")))]),
              _vm.model && _vm.browse
                ? _c("app-human-filter-list-edit", {
                    attrs: { browse: _vm.browse, model: _vm.model },
                    model: {
                      value: _vm.view.HumanFilters,
                      callback: function ($$v) {
                        _vm.$set(_vm.view, "HumanFilters", $$v)
                      },
                      expression: "view.HumanFilters",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }